import React from "react";
import { LinearProgress } from "@material-ui/core";
import PropTypes from "prop-types";

/**
 * Лёгкая обёртка над MUI LinearProgress без динамических JSS-стилей.
 * Раньше использовался withStyles с функциями от пропсов (height, radius, noborder),
 * что порождало уникальные CSS-классы для каждой карточки и вызывало зависания при >100 уроках.
 * Теперь все динамические параметры задаём через inline style.
 */
const LinearProgressBar = ({ height = 20, noborder = false, style, resetBackgroundColor, ...rest }) => {
  const rootStyle = {
    // Высота и закругление контейнера прогресса
    height,
    borderRadius: 10,
    minWidth: 40,
    // Фон и рамка контейнера
    backgroundColor: resetBackgroundColor ? "" : "white",
    border: noborder ? "none" : "1px solid #DDE1EB",
    // Внешний style имеет приоритет для возможности доп. настроек
    ...style,
  };

  return <LinearProgress style={rootStyle} {...rest} />;
};

LinearProgressBar.propTypes = {
  height: PropTypes.number,
  noborder: PropTypes.bool,
  style: PropTypes.object,
  resetBackgroundColor: PropTypes.bool,
};

export default LinearProgressBar;
